export { ImgixNextBackground } from "./imgixNextBackground";
